import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GreenCardSendNotificationComponent } from './green-card-send-notification/green-card-send-notification.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextareaModule,
    DynamicDialogModule
  ],
  declarations: [
    GreenCardSendNotificationComponent
  ],
  entryComponents: [
    GreenCardSendNotificationComponent
  ],
  exports: [
    GreenCardSendNotificationComponent,
    ReactiveFormsModule,
    DropdownModule,
    InputTextareaModule,
    DynamicDialogModule
  ]
})
export class GreenCardSharedModule { }
